import React from 'react';
import { HiArrowNarrowRight } from 'react-icons/hi';
import me from '../assets/draw.png';
import { Link } from "react-scroll";

const Home = () => {
  return (
    <div
      name="home"
      className="h-screen w-full bg-[#0a192f]"
    >
      <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row">
        <div className="flex flex-col justify-center h-full">
          <h2 className="text-4xl sm:text-7xl font-bold text-white">
            I'm a Software and AI/ML Engineer
          </h2>
          <p className="text-gray-500 py-4 max-w-md">
            With over 2 years of hands-on experience in software and machine learning engineering, 
            I thrive on the fusion of data analysis and cutting-edge software solutions. 
            My current journey involves delving into data experimentation and crafting dynamic web applications that harness the power of AI/NLP. 
            My passion lies in the seamless integration of technology to drive innovation and create meaningful solutions.
          </p>
          <div>
            <Link
              to="about"
              smooth
              duration={500}
              className="group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer"
            >
              About Me
              <span className="group-hover:rotate-90 duration-300">
                <HiArrowNarrowRight size={25} className="ml-3" />
              </span>
            </Link>
          </div>
        </div>
        <div>
          <img
            src={me}
            alt="my profile"
            className="rounded-2xl mx-auto w-2/3 md:w-full"
          />
        </div>
      </div>
    </div>
  );
};
export default Home;